import { render, staticRenderFns } from "./TourStation.vue?vue&type=template&id=bfd32ac8&"
import script from "./TourStation.vue?vue&type=script&lang=ts&"
export * from "./TourStation.vue?vue&type=script&lang=ts&"
import style0 from "./TourStation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports